import { MessageBar, MessageBarBody } from "@fluentui/react-components";
import { VSpace } from "components/Spacer";
import React from "react";
import { useTranslation } from "react-i18next";
import { ImportedInvoiceImportResult } from "types/importedInvoices";

type Props = {
  result: ImportedInvoiceImportResult;
  headline?: string; // extra first line, e.g. the window of a pull
};

// The report of an import or a pull: the counts, the insurer / client / payer codes not found
// in CRM and the warnings. Shared by the import dialog and the pull dialog (each wraps it in
// its own data-help element for the page guide).
export const ImportResultReport = ({ result, headline }: Props) => {
  const { t } = useTranslation();

  const unresolvedLine = (label: string, codes: string[]) =>
    codes && codes.length > 0 ? (
      <div>
        <b>{t(label)}:</b> {codes.join(", ")}
      </div>
    ) : null;

  return (
    <div>
      <MessageBar
        intent={
          result.unmatchedEntryCount > 0 || result.unresolvedInsurerCodes.length > 0
            ? "warning"
            : "success"
        }
      >
        <MessageBarBody>
          {headline ? (
            <>
              {headline}
              <br />
            </>
          ) : null}
          {t("pct.importImportedInvoicesResult.label", {
            imported: result.importedCount,
            updated: result.updatedCount,
            matched: result.matchedEntryCount,
            unmatched: result.unmatchedEntryCount,
          })}
        </MessageBarBody>
      </MessageBar>
      <VSpace height={10} />
      {unresolvedLine("pct.importedInvoicesUnresolvedInsurers.label", result.unresolvedInsurerCodes)}
      {unresolvedLine("pct.importedInvoicesUnresolvedClients.label", result.unresolvedClientCodes)}
      {unresolvedLine("pct.importedInvoicesUnresolvedPayers.label", result.unresolvedPayerCodes)}
      {result.warnings?.length > 0 ? (
        <div>
          <b>{t("pct.warnings.label")}:</b>
          <ul>
            {result.warnings.map((w, i) => (
              <li key={i}>{w}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};
